import { Fragment } from 'react';

import { addDays } from 'date-fns';
import { NotificationName } from 'utils/constants/notification';

import FormSpacer from 'bloko/blocks/form/FormSpacer';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import fetchCampaignsReport from 'components/Admin/Reports/CampaignsReport/fetchCampaignsReport';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import { setCampaignsReportDates } from 'store/models/campaignsReport';
import { addNotification } from 'store/models/notification';
import { useDispatch, useSelector } from 'store/utils';

const REPORT_MAX_DAYS_COUNT = 182;

const CampaignsReport = () => {
    const { from, to, isLoad } = useSelector((state) => state.campaignsReport);
    const dispatch = useDispatch();
    const trl = useTrls();

    return (
        <ReportWrapper
            title={trl('admin.SectionTabs.campaignsReport')}
            filter={
                <Fragment>
                    <div>{trl('admin.OverflowReport.Filter.SearchType.ADMIN_OVERFLOW_TYPE_BY_DATES')}</div>
                    <FormSpacer>
                        <InputWithMultiDatePicker
                            action={(from, to) => {
                                const maxDate = addDays(from, REPORT_MAX_DAYS_COUNT);
                                const isSelectedEndDateMoreThanAllowable = Number(to) > Number(maxDate);

                                if (isSelectedEndDateMoreThanAllowable) {
                                    dispatch(addNotification(NotificationName.CampaignsReportMaxDateError));
                                }

                                dispatch(
                                    setCampaignsReportDates({
                                        from,
                                        to: isSelectedEndDateMoreThanAllowable ? maxDate : to,
                                    })
                                );
                            }}
                            from={from}
                            to={to}
                            closeAfterSelect
                        />
                    </FormSpacer>
                </Fragment>
            }
            content={''}
            isLoadContent={isLoad}
            onClickCSV={() => dispatch(fetchCampaignsReport())}
        />
    );
};

export default CampaignsReport;
